class GetEt0SinceFirstLogUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(START){
    const result= await this.repository.getEt0SinceFirstLog(START)
    return result && result.length?result[0]:[];
  }
}
export {
  GetEt0SinceFirstLogUseCase,
};
